import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLSettingsTabDef, SMLSettingsTabId } from '../tabs/types';
import styles from './SettingsSubtitleStack.module.scss';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';

interface Props {
  tabs: SMLSettingsTabDef[];
  activeTab: SMLSettingsTabId;
}

/**
 * The subtitle of the open Settings tab. From md up, every subtitle sits in the same grid cell and
 * only the open one shows, so the head always has the height of the longest subtitle. The rail
 * and the pane then stay in place when you change the tab. Below md, only the open subtitle takes space.
 */
const SettingsSubtitleStackComponent: React.FC<Props> = ({ tabs, activeTab }) => {
  const intl = useIntl();

  return (
    <span className={styles.stack}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <span
            key={tab.id}
            className={isActive ? styles.current : styles.spacer}
            aria-hidden={isActive ? undefined : true}
          >
            {withBrandWord(intl.formatMessage(tab.subtitle))}
          </span>
        );
      })}
    </span>
  );
};

export const SettingsSubtitleStack = TypedMemo(SettingsSubtitleStackComponent);
